// This icon file is generated automatically.
var PMobileOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10.63-.03H3.37a1 1 0 00-1 1v12a1 1 0 001 1h7.25a1 1 0 001-1v-12a1 1 0 00-1-1zm-.13 12.87h-7V1.1h7v11.75zm-4.13-1.59a.62.62 0 101.25 0 .62.62 0 00-1.25 0z", "fill-rule": "nonzero" } }] }, "name": "p-mobile", "theme": "outlined" };
export default PMobileOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PMobileOutlined.js
// module id = 3519
// module chunks = 0